import { UseFormReturn } from 'react-hook-form';
import { IFormValue } from '@models/Forms/IForms';
import { IFieldElem } from '@models/IFormData';

/**
 * Подписи пустых полей формы, от которых зависит список выбора (`formValues`): пустой список под ними — «сначала
 * заполните поле», а не «значений нет». Подпись — `displayName`, иначе подпись поля на форме, иначе имя из ключа поля.
 */
export function getEmptyFormValueDependencies<TFieldValues extends object>(
    formValue: IFormValue[] | undefined,
    fields: Record<string, IFieldElem>,
    formMethods: UseFormReturn<TFieldValues>,
): string[] {
    const labels = (formValue ?? []).flatMap((ele) => {
        const field = !ele.formula ? fields[ele.attr] : undefined;
        if (!field) return [];
        const value = formMethods.getValues(('fields.[' + field.index + '].value') as any);
        const empty = value === null || value === undefined || value === '' || (Array.isArray(value) && !value.length);
        if (!empty) return [];
        if (ele.displayName) return [ele.displayName];
        const rendered = document
            .querySelector(`[data-document-field-index="${field.index}"] .rf-form-group-fl[id]`)
            ?.textContent?.trim();
        // поле скрыто — имя из ключа: «|Document|Бизнес_единица» → «Бизнес единица»
        return [rendered || ele.attr.replace(/^\|[^|]*\|/, '').replace(/_/g, ' ')];
    });
    return [...new Set(labels)];
}
